export default "__VITE_ASSET__C4WhgV7C__"